import { Activity } from "./Activity";
export class InfoActivity extends Activity {
    constructor(isCompleted, title, points, audio, content) {
        super();
        this.isCompleted = isCompleted;
        this.title = title;
        this.points = points;
        this.audio = audio;
        this.content = content;
    }
}
